import { createFileRoute } from '@tanstack/react-router';
import OrganizationUsersLayout from '@uturn/portal/modules/org/layouts/users-layout';

export const Route = createFileRoute('/_protected/org/$orgId/settings/users')({
	component: OrganizationUsersLayout,
});
